import React from 'react';
import { Flex, Box, Container } from 'components/Grid';
import Paragraph from 'components/Paragraph';
import Image from 'components/Image';
import Link from 'components/Link';

const Employees = props => (
	<Container>
		<Flex
			grid
			gridColumnGap={[3, 4]}
			gridRowGap={[5, 6]}
			gridTemplateColumns={['repeat(2, 1fr)', 'repeat(3, 1fr)']}
		>
			{props.employees.edges.map(item => (
				<Box
					key={item.node.id}
					cursor={item.node.cursor ? `url(${item.node.cursor.file.url}), auto` : 'play'}
				>
					<Link
						external
						to={`mailto:${item.node.email}`}
						cursor={item.node.cursor ? `url(${item.node.cursor.file.url}), auto` : 'play'}
					>
						<Image mb={[1, 4]} fluid={{ ...item.node.image.fluid, aspectRatio: 0.8 }} />
					</Link>
					<Paragraph m={0} fontWeight="bold">
						{item.node.name}
					</Paragraph>
					<Paragraph m={0}> {item.node.title} </Paragraph>
					<Link display="block" external to={`tel:${item.node.phoneNumber}`}>
						{item.node.phoneNumber}
					</Link>
					<Link display="block" external to={`mailto:${item.node.email}`}>
						{item.node.email}
					</Link>
				</Box>
			))}
		</Flex>
	</Container>
);

export default Employees;
